var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_505",
    "data-name": "Group 505",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.094,
    height: 21.705,
    viewBox: "0 0 29.094 21.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M3.463,1H25.631a2.47,2.47,0,0,1,2.463,2.463V18.241A2.47,2.47,0,0,1,25.631,20.7H3.463A2.47,2.47,0,0,1,1,18.241V3.463A2.47,2.47,0,0,1,3.463,1Z",
    fill: "none",
    stroke: "#e13505",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M.537,0H27.519",
    transform: "translate(0.547 8.852)",
    fill: "none",
    stroke: "#e13505",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.0d027b416f7ccbcf8133909adb33809d.svg";
export { ForwardRef as ReactComponent };